<template>
  <div class="rootContainer" :style="{height:screenHeight}" ref="ccc" v-if="!isWx">

    <van-icon @click="$router.go(-1)" class="close-icon" name="cross" />
    <!--导航条-->
    <!-- <navigation title="用户登录"></navigation> -->

    <!--注册信息-->
    <div class="filedContainer">
      <div class="login-top">
        <div class="login-text">
          <span>你好
          </span>
          <span>欢迎登录</span>
          <div class="line"></div>
        </div>
        <div class="login-icon"></div>
      </div>
      <van-row>
        <van-col class="colLeft" span="2">
          <van-icon class="iconfont" class-prefix='icon' name='shouji1' style="font-size: 20px" />
        </van-col>
        <van-col class="colRight" span="22">
          <van-field v-model="data.mobile" type="text" placeholder="输入手机号码" />
        </van-col>
      </van-row>

      <van-row style="margin-top: 10px">
        <van-col class="colLeft" span="2">
          <van-icon class="iconfont" class-prefix='icon' name='mima' style="font-size: 20px" />
        </van-col>
        <van-col class="colRight" span="16">
          <van-field v-model="data.password" :type="isPwd" placeholder="请输入登录密码" />
        </van-col>
        <van-col class="colBottom" span="6">
          <van-icon class="iconfont" class-prefix='icon' @click="isPwd == 'password' ? isPwd = 'text':isPwd = 'password'" name='yanjing' style="font-size: 20px;" />
        </van-col>

      </van-row>
      <div class="forget-pwd" @click="navToForgetPwd">忘记密码？</div>

      <van-button class="btSubmitStyle" color="#D6BE93" type="primary" @click="navToLogin">登录</van-button>
      <div style="text-align: center;margin-top: 15px;font-size: 1.4rem;">
        没有账户? <span style="font-weight: bold;color: #D6BE93;text-decoration: underline;" @click="registerNow">立即注册</span>
      </div>

    </div>

  </div>
  <div v-else>
    <div class="wechat-tip">
      <van-icon name="wechat" class="wechat-icon" />
      <div class="wechat-text">该网页由CruItaly意品之家开发，向其提供以下权限即可继续操作</div>
    </div>
    <van-button class="wechat-btn" type="primary" block @click="getCode">确认登陆</van-button>
  </div>
</template>

<script>
import navigation from "../../components/navigation";
import "../../assets/appicons/font_1719792_w8dw4niwvmq/iconfont.css";

import { login, wxGetCode } from "@/api/index";
import { Dialog } from "vant";

export default {
  name: "sigin",
  components: {
    navigation,
  },
  data() {
    return {
      screenHeight: document.body.clientWidth,
      hasBack: false,
      value: "",
      value1: "",
      isPwd: "password",
      data: {
        mobile: "", //账号
        password: "", //密码
      },
      isWx: false,
    };
  },
  mounted() {
    window.addEventListener("resize", function () {
      this.screenHeight = document.body.clientHeight + "px";
    });
    let ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
    if (ua.indexOf("micromessenger") >= 0) {
      this.isWx = true;
    } else {
      this.isWx = false;
    }
  },
  methods: {
    getCode() {
      // 非静默授权，第一次有弹框
      // alert(JSON.stringify(window.location.search));
      const code = this.getQueryString("code");
      if (code == null || code === "") {
        console.log("??????????????hahahhahahah");
        var url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe5617ba8b2e20ab1&redirect_uri=https%3a%2f%2fcruitaly.cafewallet.cn%2f%23%2fperson&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect";
        window.location.href = url;
      } else {
        localStorage.setItem("code", code);
        this.getOpenId(code); //把code传给后台获取用户信息
      }
      // https://cruitaly.cafewallet.cn/?code=0017Y1ll27Nni64dcKml2GLkjy37Y1lP&state=STATE#/login
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },

    getOpenId(code) {
      // 通过code获取 openId等用户信息，/api/user/wechat/login 为后台接口
      wxGetCode({ code: code }).then((res) => {
        console.log(res);
        this.$store.commit("SET_USERINFO", res.data.data);
        sessionStorage.setItem("Token", res.data.data.token);
        this.$router.push("/person");
      });
    },
    registerNow() {
      this.$router.push("/register");
    },
    navToLogin() {
      console.log(this.data);
      console.log(this.data.mobile.length);
      if (
        this.data.mobile == "" ||
        this.data.password == "" ||
        this.data.mobile.length != 11
      ) {
        Dialog.alert({
          title: "提示",
          message: "请填写正确的用户名或密码",
        });
        return;
      }
      login(this.data).then((res) => {
        if (res.data.errno == 0) {
          sessionStorage.setItem("Token", res.data.data.token);
          this.$store.commit("SET_USERINFO", res.data.data);
          // this.$router.push({ path: "/index" });

          this.$router.go(-1);
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg,
          });
        }
      });
    },
    navToForgetPwd() {
      this.$router.push("/forgetPwd");
    },
  },
};
</script>



<style lang="scss" scoped>
.colLeft {
  background-color: white;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: justify;
}
.colRight {
  // background-color: transparent;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: justify;
}
.colBottom {
  // background-color: transparent;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: justify;
}
.forget-pwd {
  font-family: PingFangSC-Medium;
  font-size: 1.4rem;
  color: #d6be93;
  line-height: 2.1rem;
  text-align: right;
}

.rootContainer {
  background-color: white;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.filedContainer {
  padding: 10% 10% 0px 10%;
  background-color: white;
  // background-color: transparent;
  height: 100%;
  .login-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5rem;
    .login-text {
      font-size: 1.75rem;
      font-weight: bold;
      display: flex;
      text-align: left;
      flex-direction: column;
      .line {
        background: #222b45;
        border-radius: 2.5px;
        width: 3.1rem;
        height: 0.5rem;
        margin-top: 1.2rem;
      }
      span {
        font-family: PingFangSC-Medium;
        font-size: 2.8rem;
        color: #222b45;
        line-height: 4rem;
      }
    }
    .login-icon {
      width: 6.8rem;
      height: 6.8rem;
      background: url("../../assets/index/logo_img.png") center center no-repeat;
      background-color: #d6be93;
      // border: 0.875rem solid #8f9bb3;
      border-radius: 50%;
      opacity: 0.5;
      box-sizing: border-box;
    }
  }
}
.btSubmitStyle {
  width: 100%;
  border-radius: 5px;
  margin-top: 4rem;
}
/deep/ .van-row {
  border-bottom: 1px solid #c2c2c2;
  width: 100%;
  overflow: hidden;
  height: 6.8rem;
  display: flex;
  align-items: flex-end;
  box-sizing: border-box;
  padding-bottom: 0.4rem;
}
/deep/ .icon-shouji1 {
  font-weight: 600;
  font-size: 2.2rem;
}
/deep/ .icon-mima {
  font-weight: 600;
  font-size: 2.2rem;
}
/deep/ .van-icon,
.van-icon::before {
  display: inline-block;
  width: 100%;
  text-align: left;
  font-size: 2.4rem;
  margin: 1rem;
}

// 微信浏览器授权页面

.wechat-tip {
  height: 22rem;
  width: 100vw;
  background: #07c160;
  color: #fff;
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;
  align-items: center;
  justify-content: center;
  .wechat-text {
    padding: 0 2rem;
    box-sizing: border-box;
    color: #fff;
    margin: 0 1rem;
    font-size: 1.4rem;
  }
  .wechat-icon::before {
    text-align: center;
    font-size: 7rem;
  }
}
.wechat-btn {
  margin: 0 auto;
  box-sizing: border-box;
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/view/pages/sigin.vue